import styled from 'styled-components'

export const ContainerContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  max-width: 1010px;
  padding: 10px;
`
export const ContainerContentListInfo = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1010px;
  padding: 10px;
`

export const ContainerTemplate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => {
    return theme.colors.background
  }};
`

export const ContainerPages = styled.div`
  display: flex;
  height: 100vh;
  align-items: flex-start;
  position: relative;
  z-index: 5;
  background-image: url('/images/background.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`
